import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
    state: () => ({
        user: {},
        isLoggedIn: false,
        loadingUserInfo: false
    }),

    actions: {
        setUser(user) {
            this.user = user;
            this.isLoggedIn = !!user && Object.keys(user).length > 0;
        }
    }
});